import React from "react";
import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getPlaceHolderNames, replaceHoldersInRichText } from "../../utilities/HtmlUtils";
import { getFieldByName, getRootComponent, isFirstElement, isLastElement } from '../../utilities/ElementUtils';
import TimeEstimateCalloutComponent from "../odsCalloutBox/TimeEstimateComponent";
import axios from "axios";
import { cleanup } from "../../security/PublicSecure";



interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  value?: any;
  callbackStepIndex?: (index: number, currentIndex?: number) => void;
}

interface State {
  isVisible: boolean;

}
export class RichTextComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
    let field = this.props.field;
    this.state = {
      isVisible: field.Visible
    };
    FormValidationUtils.runJavascript(field);
  }

  componentDidMount(): void {
    // const holders = getPlaceHolderNames(this.props.field.Value ?? this.props.value);
    this.addGoToStepAction();
    this.integrateCxpHandler();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    //if (!prevState.isVisible && this.state.isVisible) {
      this.addGoToStepAction();
      this.integrateCxpHandler();
    //}
  }

  componentWillUnmount(): void {
    const buttons = document.getElementsByClassName('gotoStep');
    const section = this.props.field.parent.parent as FormSections;
    const programContainer = section.parent as ProgramContainer;
    const currentIndex = programContainer.ListOfFormSections.findIndex(p => p.Id == section.Id);
    for (var i = 0; i < buttons.length; i++) {
      if (buttons.item(i).attributes.getNamedItem("data-index")) {
        const nextIndex = Number.parseInt(buttons.item(i).attributes.getNamedItem("data-index").value);
        buttons.item(i).removeEventListener('click', () => {
          this.props.callbackStepIndex(nextIndex, currentIndex);
        });
        buttons.item(i).removeEventListener('contextmenu', (e) => { e.preventDefault(); });
      }
    }

    const links = document.querySelectorAll('a.cxp-integration');
    if (links.length) {
      links.forEach((link) => {
        link.removeEventListener('click', this.handleCxpLinkClick);
      });
    }
  }

  addGoToStepAction = () => {
    const buttons = document.getElementsByClassName('gotoStep');
    const section = this.props.field.parent.parent as FormSections;
    const programContainer = section.parent as ProgramContainer;
    const currentIndex = programContainer.ListOfFormSections.findIndex(p => p.Id == section.Id);
    for (var i = 0; i < buttons.length; i++) {
      if (buttons.item(i).attributes.getNamedItem("data-index")) {
        const nextIndex = Number.parseInt(buttons.item(i).attributes.getNamedItem("data-index").value);
        buttons.item(i).addEventListener('click', (e) => {
          e.preventDefault();
          this.props.callbackStepIndex(nextIndex, currentIndex);
        });
        buttons.item(i).addEventListener('contextmenu', (e) => { e.preventDefault(); });
      }
    }
  }

  handleProcess = async (fieldName: string) => {
    const root = getRootComponent(this.props.field);
    const profile = root?.Profile;
    const bindField = getFieldByName(fieldName, this.props.field);
    if (root.Profile?.eamil && bindField) {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${profile.token}`,
      }
      const value = bindField.Value;
      const response = await axios.post(`${process.env.PUBLIC_OTRIS_API_BASE_PATH}/transfer-log`, {
        payeeId: bindField.Value,
        email: profile.email,
      }, { headers });

      if (response.status == 200) {
        return response.data.webResponse?.statusCode === 0;
      } 
    }
    return false;
  };

  handleCxpLinkClick = async (e) => {
    e.preventDefault();
    const link = e.target;
    const path = link.dataset.path;
    if (path) {
      const fieldName = link.dataset.field;
      if (fieldName) {
        await this.handleProcess(fieldName);
      }
      const url = `${process.env.PUBLIC_CXP_WEB_BASE_PATH}/auth/signin?redirectUri=${this.props.isEng? '' : '/fr'}/${path}`;
      console.log("Redirecting to:", url);
      const root = getRootComponent(this.props.field);
      cleanup(root.CategoryId.toLowerCase(), root);
      window.location.replace(url);
    }
  }

  integrateCxpHandler = () => {
    const links = document.querySelectorAll('a.cxp-integration');
    if (links.length) {
      links.forEach((link) => {
        link.addEventListener('click', this.handleCxpLinkClick);
      });
    }
  }

  render() {
    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();

    let field = this.props.field;
    if (!field.Visible) return null;

    let controlArray = [];
    let displayfield = true;

    if (this.props.field.FilterField != null && this.props.field.FilterField.length > 0) {
      let filterValue;
      let baseName;
      let bindName;

      let toDisplay = [];

      let filterField = [];

      if (Array.isArray(this.props.field.FilterField)) {
        filterField.push(...this.props.field.FilterField)
      } else {
        filterField.push(this.props.field.FilterField)
      }

      filterField.forEach((filterField) => {
        let parts;

        if (Array.isArray(filterField)) {
          parts = filterField[0].split('.');
        }
        else {
          parts = filterField.split(".");
        }

        if (parts.length == 3) {
          baseName = parts[0] + '.' + parts[1];
          bindName = parts[2];
        }
        if (parts.length == 2) {
          baseName = parts[0];
          bindName = parts[1];
        }
        if (parts.length == 1) {
          baseName = '';
          bindName = parts[0];
        }

        let foundFilterField = XMLParser.findSectionElement(field, bindName);
        try {
          if (foundFilterField != null) {
            filterValue = foundFilterField.Value;



            let fieldValue = this.props.field.FilterValue[foundFilterField.LoadBindName]

            //   if (filterValue==null &&  filterValue && fieldValue?.indexOf(filterValue) == -1) {
            //     toDisplay.push(false);
            //   } else {
            //     toDisplay.push(true);
            //   }
            // } else {
            //   toDisplay.push(true);
            // }

            if (fieldValue) {
              if (fieldValue?.indexOf(filterValue) == -1) {
                toDisplay.push(false);
              } else {
                toDisplay.push(true);
              }
            }
          }
        } catch (ex) {
          console.log(ex);
        }

      })

      displayfield = toDisplay.filter(p => p == false).length == 0;

    }

    if (displayfield) {
      if (!this.state.isVisible) this.setState({ isVisible: true });
      const txt = (this.props.isEng ? field.Value : field.ValueFRA) ?? (this.props.value || "");
      const root = getRootComponent(field);
      const replacement = replaceHoldersInRichText(root?.CategoryId, txt, field, this.props.isEng ? 'en' : 'fr');
      const reactElement = htmlToReactParser.parse(replacement);
      let labelContent = [];
      const p1 = field.parent;
      const p2 = field.parent.parent;
      if (field.wrapCalloutbox) {
        labelContent.push(
          <div id={`Label-${field.parent.parent.Id}-${field.parent.Sequence}-${field.Id}`}
            className="callout-component"
          >
            {reactElement}
          </div>
        );
      } else {
        labelContent.push(
          <div id={`Label-${this.props.field.parent.parent.Id}-${this.props.field.parent.Sequence}-${this.props.field.Id}`}
            style={{ marginTop: '2rem', alignContent: 'center', alignItems: 'center', width: '100%' }}
          >
            {reactElement}
          </div>
        );
      }
      let wrapBoxType; // = isFirstElement(field) ? 'ontario-margin-top-24-!' : isLastElement(field) ? 'ontario-margin-bottom-24-!' : '';

      switch (field.wrapCalloutbox) {
        case 'general':
          wrapBoxType = "ontario-callout callout-max-width";
          break;
        case 'timeEstimate':
          labelContent = [];
          labelContent.push(
            <TimeEstimateCalloutComponent field={field}>{reactElement}</TimeEstimateCalloutComponent>
          );
          break;
        case 'informational':
          wrapBoxType = "ontario-alert ontario-alert--informational callout-max-width";
          break;
        case 'warning':
          wrapBoxType = "ontario-alert ontario-alert--warning callout-max-width";
          break;
        case 'success':
          wrapBoxType = "ontario-alert ontario-alert--success callout-max-width";
        case 'error':
          wrapBoxType = "ontario-alert ontario-alert--error callout-max-width";
          break;
        default:
          wrapBoxType = "";
      }

      controlArray.push(
        <div className={`${wrapBoxType ?? ''}`}>
          {labelContent}
        </div>
      );
    } else if (this.state.isVisible) {
      this.setState({ isVisible: false });
    }

    return controlArray;
  }
}